import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const locationBaseUrl = `${apiUrl}/location`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const locationApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${locationBaseUrl}?${query}`);
  },
  save: location => {
    return Axios.post(locationBaseUrl, location, config);
  },
  delete: id => {
    return Axios.delete(`${locationBaseUrl}/${id}`, config);
  },

};
